export default __webpack_public_path__ + "aea83c7e45005da5d398d5bd7df79b0a.png";